import { Link } from 'react-router-dom'
import type { Verknuepfung } from '../../hooks/useVerknuepft'
import s from './Verknuepfungen.module.scss'

/**
 * Der Block „Verknüpft" — was im System zu den Zielen schon steht.
 *
 * EIN BAUTEIL FÜR MELDUNGEN UND EREIGNISSE: Je Zeile ein Punkt in der Farbe
 * des Zustands, die Art in Kapitälchen, der Text als Link dorthin. Solange
 * gesucht wird, steht „sucht …"; ohne Treffer „keine Verknüpfung" — beides
 * gedämpft, weil es keine Auskunft über das Ziel ist, sondern über uns.
 */
export function Verknuepfungen({ eintraege, laedt }: {
  eintraege: Verknuepfung[]
  laedt: boolean
}) {
  if (eintraege.length === 0) {
    return <span className={s.keine}>{laedt ? 'sucht …' : 'keine Verknüpfung'}</span>
  }
  return (
    <div className={s.liste}>
      {eintraege.map((v, i) => (
        <Link key={i} to={v.to} className={s.eintrag}>
          <span className={s.punkt} data-ton={v.ton} title={v.status} />
          <span className={s.typ}>{v.typ}</span>
          <span>{v.text}</span>
        </Link>
      ))}
    </div>
  )
}
